<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <div :class="domClass" />
</template>

<script>
import axios from "axios"
import dropin from "braintree-web-drop-in"

const defaultBraintreeContainer = "braintree-dropin"
let instance

export default {
  name: "BraintreeDropin",

  props: {
    customerId: {
      type: String,
      default: ""
    }
  },
  //
  data: () => ({
    domClass: defaultBraintreeContainer
  }),

  created() {
    this.init()
  },

  beforeDestroy() {
    console.log("beforeDestroy")
    instance && instance.teardown()
  },

  methods: {
    init() {
      return axios
        .get(
          "/services/braintree/clienttoken" +
            (this.customerId ? `/${this.customerId}` : "")
        )
        .then(response => {
          const token = response.data

          return dropin.create({
            authorization: token,
            container: document.querySelector(`.${this.domClass}`),
            preselectVaultedPaymentMethod: true
          })
        })
        .then(_instance => {
          instance = _instance
          this.$emit("ready", _instance)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BraintreeDropin.vue